import { render, staticRenderFns } from "./forgot-password-by-username.vue?vue&type=template&id=99a7ae32&scoped=true&"
import script from "./forgot-password-by-username.vue?vue&type=script&lang=js&"
export * from "./forgot-password-by-username.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&id=99a7ae32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a7ae32",
  null
  
)

component.options.__file = "forgot-password-by-username.vue"
export default component.exports